let swiperInstance = null;

function initSwiper() {
  // 既存のインスタンスがあれば完全に破棄してから作り直す
  if (swiperInstance) {
    swiperInstance.destroy(true, true);
    swiperInstance = null;
  }

  const swiperEl = document.querySelector('.swiper');
  if (!swiperEl) return;

  swiperInstance = new Swiper(swiperEl, {
    slidesPerView: 1,
    loop: true,
        autoplay: {
    delay: 4000,
    disableOnInteraction: false, // ユーザー操作後も自動再生を継続
  },

    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
}

document.addEventListener('DOMContentLoaded', initSwiper);

// テーマエディタでセクションが再読込・再描画されたときに再初期化
document.addEventListener('shopify:section:load', initSwiper);

// ブロック選択時にも念のため再初期化（プレビューのズレ防止）
document.addEventListener('shopify:block:select', initSwiper);